import { registerLocaleData, NumberSymbol } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { ɵLocaleDataIndex } from '@angular/core';
import { environment } from '@base/environments/environment';
import {
  getRegionNumberFormat,
  RegionNumberFormat,
} from '../core/number-format/region-number-format.config';

export function getTenantLocaleId(node: string = environment.node): string {
  return getRegionNumberFormat(node).locale;
}

export function registerTenantLocale(node: string = environment.node): void {
  const format = getRegionNumberFormat(node);
  registerLocaleData(withNumberSymbols(localeEs as any[], format) as any, format.locale);
}

function withNumberSymbols(baseLocale: any[], format: RegionNumberFormat): any[] {
  // Shallow clone so the shared 'es' locale data is not mutated
  const clone = [...baseLocale];
  const numberSymbols = [...(clone[ɵLocaleDataIndex.NumberSymbols] as string[])];

  numberSymbols[NumberSymbol.Decimal] = format.decimal;
  numberSymbols[NumberSymbol.Group] = format.group;

  clone[ɵLocaleDataIndex.NumberSymbols] = numberSymbols;
  return clone;
}
